<template>
  <div>
    <Header
      :showRegistrationModal = "showRegistrationModal"
      :showLoginModal = "showLoginModal"
      :settings = "settings"
      @openRegModal ="openRegModal"
      @openLogModal ="openLogModal"
    >
    </Header>
    <div class="p-breadcrumb bg-benefits">
      <v-container class="" pa-0>
        <h1>{{$t('benefits')}}</h1>
      </v-container>
    </div>
    <v-container class="container-xxl mt-5">
      <div class="p-benefits">
        <v-layout row wrap>
          <v-flex lg8 md10 sm12 offset-lg2 offset-md1>
            <div class="benefit-block-wrapper">
              <div class="benefit-block">
                <img src="../assets/images/icons/box.svg" alt="">
                <div class="benefit-block-content">
                  <h2>{{$t('give_&_receive')}}</h2>
                  <p>{{$t('give_&_receive_text')}}</p>
                </div>
              </div>
              <div class="benefit-block">
                <img src="../assets/images/icons/handshake.svg" alt="">
                <div class="benefit-block-content">
                  <h2>{{$t('features.find_gift_recipient')}}</h2>
                  <p>{{$t('features.find_gift_recipient_text')}}</p>
                </div>
              </div>
              <div class="benefit-block">
                <img src="../assets/images/icons/charity2.svg" alt="">
                <div class="benefit-block-content">
                  <h2>{{$t('give_and_receive')}}</h2>
                  <p>{{$t('give_and_receive_text')}}</p>
                </div>
              </div>
              <div class="benefit-block">
                <img src="../assets/images/icons/donation.svg" alt="">
                <div class="benefit-block-content">
                  <h2>{{$t('features.no_exchange')}}</h2>
                  <p>{{$t('features.no_exchange_text')}}</p>
                </div>
              </div>
              <div class="benefit-block">
                <img src="../assets/images/icons/donate.svg" alt="">
                <div class="benefit-block-content">
                  <h2>{{$t('features.non_trade')}}</h2>
                  <p>{{$t('features.non_trade_text')}}</p>
                </div>
              </div>
              <div class="benefit-block">
                <img src="../assets/images/icons/giver.svg" alt="">
                <div class="benefit-block-content">
                  <h2>{{$t('giver_community')}}</h2>
                  <p>{{$t('giver_community_text')}}</p>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
  </div>
</template>

<script>
import Header from '../components/global/Header.vue'
const getSettings = function (settings, lang) {
  let _settings = []
  if (settings) {
    settings.forEach(setting => {
      setting.SettingTranslations.forEach(st => {
        if (!setting.value) {
          setting.value = st.value
        }
        if (st.languageId === lang.id) {
          setting.value = st.value
        }
      })
      _settings.push(setting)
    })
  }
  return _settings
}
export default {
  name: 'About',
  components: {
    Header
  },
  data: () => ({
    settings: [],
    confirmedEmailText: '',
    confirmedEmailType: 'error',
    showRegistrationModal: false,
    showLoginModal: false
  }),
  methods: {
    languageChanged (lang) {
      this.settings = getSettings(this.settings, lang)
    },
    openRegModal () {
      this.showRegistrationModal = !this.showRegistrationModal
    },
    openLogModal () {
      this.showLoginModal = !this.showLoginModal
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/sass/global/variables";
  @import "../assets/sass/desktop/benefitsPage";
</style>



// WEBPACK FOOTER //
// src/views/BenefitsPage.vue